// /src/renderer/app/AppRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainShell from '@layout/MainShell/MainShell';
import LoginShell from '@layout/LoginShell/LoginShell';
import { BrowserPage } from '@features/browser';
import { LoginPage } from '@features/auth';
import { AnalysisPage } from '@features/analysis';
import PrivateRoute from '@features/auth/PrivateRoute';
import PopupPage from './PopupPage';
import { BackofficePage } from '@features/backoffice';
const AppRoutes: React.FC = (): React.JSX.Element => {
  return (
    <Routes>
      {/* <Route path="/login" element={<LoginPage />} /> */}
      <Route path="/" element={<LoginShell />}>
        <Route index element={<LoginPage />} />
      </Route>

      {/* Browser Page */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainShell />
          </PrivateRoute>
        }
      >
        <Route path="browser" element={<BrowserPage />} />
        {/* 추가 경로 설정 */}
      </Route>

      <Route
        path="/backoffice/*"
        element={
          <PrivateRoute>
            <BackofficePage />
          </PrivateRoute>
        }
      />
      {/* Analysis Page */}
      <Route
        path="/analysis"
        element={
          <PrivateRoute>
            <MainShell />
          </PrivateRoute>
        }
      >
        <Route index element={<AnalysisPage />} />
        <Route path=":id" element={<AnalysisPage />} />
      </Route>
      <Route path="/popup" element={<PopupPage />} />
    </Routes>
  );
};

export default AppRoutes;
